<template>
  <div class="reg-form">
    <h3 class="reg-title">绑定手机号</h3>
    <div class="">
      <van-field v-model="username" label="姓名" placeholder="请输入姓名" />
      <van-field v-model="phone" type="tel" label="手机号" placeholder="请输入手机号" maxlength="11" />
      <van-field
        v-model="code"
        maxlength="6"
        autocomplete="off"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button size="small" type="primary" v-if="count>=90" @click="getCode" native-type="button">发送验证码</van-button>
          <van-button size="small" type="primary" disabled native-type="button" v-else>倒计时 {{count}} s</van-button>
        </template>
      </van-field>
    </div>
    <van-button type="default" class="reg-btn" @click="regForm">确认提交</van-button>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Button, RadioGroup, Radio, Form, Field, Popup, Cell } from 'vant'

  var payToUrl = ''

  export default {
    components: {
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Form.name]: Form,
      [Field.name]: Field,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
    },
    name: 'binding',
    data () {
      return {
        username: '',
        phone: '',
        code: '',
        verification_key: '',
        count: 90,
        timer: null,
      }
    },
    created: function () {

      this.getUser()
    },
    destroyed() {
      clearInterval(this.timer);
    },
    beforeRouteEnter(to, from, next){
      next(vm =>{
        //console.log(from) // 上一页面的路由信息
        payToUrl = from.fullPath
        console.log(payToUrl)
      })
    },
    methods: {
      getUser() {
        this.$api.get('user', null, r=>{
          this.user = r.data
          this.username = r.data.name
          this.phone = r.data.phone
        })
      },
      formatter(value) {
        // 过滤输入的数字
        return value.replace(/\d/g, '');
      },
      //获取验证码
      getCode() {
        if (!this.phone.length) {
          this.$toast('请输入手机号');
        } else if (!this.common.verifyPhone(this.phone)) {
          // !/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(this.phone)
          this.$toast('请输入正确的手机号码');
          return
        } else {
          // 发送验证码
          this.$api.post('verificationCodes', {phone:this.phone}, r=>{
            if(r.success === 1){
              this.$toast(r.message)
              this.verification_key = r.data.key
              this.timer = setInterval(()=>{
                this.count --
                if(this.count<=0){
                  clearInterval(this.timer);
                  this.count = 90;
                }
              },1000)
            }
          })
        }
      },
      regForm() {
        if(this.username.trim() == ''){
          this.$toast('姓名不能为空')
          return
        }
        if(this.phone.trim() == ''){
          this.$toast('手机号不能为空')
          return
        }
        if(!this.common.verifyPhone(this.phone)){
          this.$toast('请输入正确的手机号码');
          return
        }
        if(this.code.trim() == ''){
          this.$toast('短信验证码不能为空')
          return
        }
        let self = this
        this.$api.post('user/binding', {name:this.username, phone:this.phone, verification_code: this.code, verification_key: this.verification_key}, r=>{
          this.$toast({'message':'绑定成功', onOpened:function(){
              self.$router.push(payToUrl)
          }})
        })
      }
    },
  }
</script>

<style scoped>
  .reg-form{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
  }
  .reg-title{
    text-align: center;
    font-weight: normal;
    font-size: 18px;
    color:#646566;
    margin-top:60px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 15px auto 0;
    display: inherit;
  }
  .reg-msg{
    font-size: 13px;
    padding:15px;
    color: #b4b1bc;
    line-height: 25px;
  }
  .reg-login a{
    color:#ED6B0D;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/binding.vue